import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";
import BuilderVisual from "./BuilderVisual";

const TRUST = ["Factory Direct Purchasing", "Multiple Manufacturers", "One Container", "One Workspace"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-28 sm:pt-36 pb-16 sm:pb-24" data-testid="hero-section">
      <div className="absolute inset-0 dm-grid-bg [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,black,transparent)]" />
      <div className="dm-container relative">
        <motion.div variants={stagger} initial="hidden" animate="visible"
          className="grid lg:grid-cols-[1fr_1.05fr] gap-12 lg:gap-10 items-center">
          <div className="max-w-xl">
            <motion.span variants={fadeUp} className="dm-eyebrow" data-testid="hero-eyebrow">
              <span className="h-1.5 w-1.5 rounded-full bg-blue-600" />
              Procurement Model
            </motion.span>
            <motion.h1 variants={fadeUp}
              className="mt-5 text-5xl sm:text-6xl lg:text-[4.25rem] font-extrabold leading-[1.02] text-slate-900"
              data-testid="hero-headline">SmartContainer™</motion.h1>
            <motion.p variants={fadeUp} className="mt-5 text-xl sm:text-2xl font-semibold text-slate-800 leading-snug">
              One Container.<br className="hidden sm:block" /> Multiple Manufacturers.<br className="hidden sm:block" /> One Procurement Operation.
            </motion.p>
            <motion.p variants={fadeUp} className="mt-5 text-base sm:text-lg text-slate-500 leading-relaxed">
              Build one container with products sourced directly from multiple verified Turkish manufacturers, while DeMaxtore coordinates the entire procurement process through one connected Workspace.
            </motion.p>
            <motion.div variants={fadeUp} className="mt-8 flex flex-wrap gap-3">
              <button className="dm-btn-primary" data-testid="hero-primary-cta">Build Your SmartContainer™<ArrowRight className="h-4 w-4" strokeWidth={2} /></button>
              <button className="dm-btn-secondary" data-testid="hero-secondary-cta">Create Your Free Workspace</button>
            </motion.div>
            <motion.ul variants={fadeUp} className="mt-9 grid grid-cols-2 gap-y-3 gap-x-4" data-testid="hero-trust-bar">
              {TRUST.map((t) => (
                <li key={t} className="flex items-center gap-2">
                  <span className="grid place-items-center h-5 w-5 rounded-full bg-emerald-50"><Check className="h-3 w-3 text-emerald-600" strokeWidth={3} /></span>
                  <span className="text-sm font-medium text-slate-600">{t}</span>
                </li>
              ))}
            </motion.ul>
          </div>
          <motion.div variants={fadeUp} className="relative">
            <div className="absolute -inset-4 rounded-3xl bg-blue-50/50 blur-2xl -z-10" />
            <BuilderVisual />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
